$(function() {
    window.pickdate = {};

    $('.js-date-value').pickadate({
        format: 'dd. mmmm yyyy',
        formatSubmit: 'dd/mm/yyyy',
        hiddenName: true,
        clear: '',
        onSet: function() {
            hideResults();
            activateDateButton();
        }
    });

    $('.js-date-button').click(function(e) {
        e.preventDefault();
        var picker = $('.js-date-value').pickadate('picker');
        pickdate.dateValue = picker.get();
        pickdate.dateObject = picker.get('select', 'yyyy-mm-dd');

        if(!pickdate.dateValue) {
            return false;
        }

        calculateResults();
        displayResults();
    });

    function hideResults() {
        $('.js-date-results').addClass('isInvisible');
    }

    function displayResults() {
        $('.js-date-results').removeClass('isInvisible');
    }

    function activateDateButton() {
        $('.js-date-button').removeClass('isInactive');
    }

    function calculateMaternityleade(selectedDate) {
        var result = new Date(selectedDate);
        // remove 42 days (6 weeks) to birthday date
        result.setDate(result.getDate() - 42);
        return result;
    }

    function calculateBirthdate(selectedOption) {
        var selectedDate = new Date(pickdate.dateObject);
        var result = new Date(selectedDate);

        if(selectedOption == 'regel') {
            // add 7 days to selected date
            result.setDate(result.getDate() + 7);
            // add 3 month
            result.setMonth(result.getMonth() - 3);
            // add 1 year
            result.setFullYear(result.getFullYear() + 1);

        } else if (selectedOption == 'zeugung') {
            // add 266 days to selected date
            result.setDate(result.getDate() + 266);
        }

        return result;
    }

    function calculateResults() {
        var selectedOption = $('input[name=geburtstermin-option]:checked').val();
        var birthday = calculateBirthdate(selectedOption);
        var maternityleave = calculateMaternityleade(birthday);

        var displayedBirthdayMonth = birthday.toLocaleString('de-DE', { month: "long" });
        var displayedMaternityleaveMonth = maternityleave.toLocaleString('de-DE', { month: "long" });

        if(get_browser().version < 10) {
            displayedBirthdayMonth = birthday.getMonth() + 1 + '. ';
            displayedMaternityleaveMonth = maternityleave.getMonth() + 1 + '. ';
        }

        $('.js-date-results-birthdate').html(birthday.getDate() + '. ' + displayedBirthdayMonth + ' ' + birthday.getFullYear());
        $('.js-date-results-maternityleave').html(maternityleave.getDate() + '. ' + displayedMaternityleaveMonth + ' ' + maternityleave.getFullYear());
    }

    function get_browser() {
        var ua=navigator.userAgent,tem,M=ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        if(/trident/i.test(M[1])){
            tem=/\brv[ :]+(\d+)/g.exec(ua) || [];
            return {name:'IE',version:(tem[1]||'')};
            }
        if(M[1]==='Chrome'){
            tem=ua.match(/\bOPR|Edge\/(\d+)/)
            if(tem!=null)   {return {name:'Opera', version:tem[1]};}
            }
        M=M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
        if((tem=ua.match(/version\/(\d+)/i))!=null) {M.splice(1,1,tem[1]);}
        return {
            name: M[0],
            version: M[1]
        };
    }

});
